var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useContext, useEffect } from 'react';
import RadioStyle, { RadioWrapperStyle, RadioCircleStyle, } from './RadioStyle';
import RadioContext from './RadioContext';
import LabelContext from '../Label/LabelContext';
const Radio = React.forwardRef((_a, ref) => {
    var { className, onChange, variant, disabled, id, checked: defaultChecked, error: errorProp, value } = _a, otherProps = __rest(_a, ["className", "onChange", "variant", "disabled", "id", "checked", "error", "value"]);
    const [focus, setFocus] = useState(false);
    const { setChecked, checked: checkedProp, name, error: errorGroup, } = useContext(RadioContext);
    const { setActive } = useContext(LabelContext);
    const checked = checkedProp === id;
    const error = errorProp || errorGroup || false;
    // Make the label aware of changes in the checked state
    useEffect(() => {
        setActive(checked);
    }, [checked, setActive]);
    // Pass default `checked` to RadioGroup on load and when `id` changes
    useEffect(() => {
        if (defaultChecked)
            setChecked(id);
    }, [id, defaultChecked, setChecked]);
    return (React.createElement(RadioWrapperStyle, Object.assign({}, {
        focus,
        error,
        className,
        variant,
        disabled,
        checked,
    }, { "aria-disabled": disabled }),
        React.createElement(RadioCircleStyle, Object.assign({}, {
            error,
            disabled,
            focus,
            variant,
            checked,
        })),
        React.createElement(RadioStyle, Object.assign({}, Object.assign(Object.assign({}, otherProps), { disabled,
            id,
            name,
            value,
            checked,
            ref }), { onFocus: () => {
                setFocus(true);
            }, onBlur: () => setFocus(false), onChange: (e) => {
                if (onChange) {
                    onChange(e);
                }
                setChecked(e.target.id);
            } }))));
});
export default Radio;
//# sourceMappingURL=Radio.js.map